module.exports = __webpack_public_path__ + "static/media/p_53_2.23c2595b.png";